import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import DetailViewHeader from '#/shared/components/DetailViewHeader';
import StyledSwitch from '#/shared/components/StyledSwitch';
import RouteBadge from '#/shared/components/RouteBadge';
import { routeTypeToMode } from '#/transit-tracker/utils/routes';
import { transitVehicleType } from '#/prop-types/otp-ui';
import { simpleRouteType } from '#/prop-types';
import * as Styled from './styled';

function VehicleDetailHeader({
  vehicle,
  route,
  vehicleCenteringActive,
  centerVehicleOnMap,
}) {
  const intl = useIntl();
  return (
    <DetailViewHeader
      title={
        <Styled.MessageBlock>
          <FormattedMessage
            id="detailview.vehiclerouteto"
            values={{ route: route.vanityName, to: vehicle.signMessage }}
          />
          <StyledSwitch
            rightText={intl.formatMessage({ id: 'detailview.vehiclefollow' })}
            checked={vehicleCenteringActive}
            onCheckedChange={centerVehicleOnMap}
          />
        </Styled.MessageBlock>
      }
      icon={
        <>
          <Styled.VehicleIcon mode={routeTypeToMode(route)} />
          <Styled.RouteBadgeWrapper>
            <RouteBadge routeId={route.id} useScaling={false} useBorder />
          </Styled.RouteBadgeWrapper>
        </>
      }
    />
  );
}

VehicleDetailHeader.propTypes = {
  vehicle: transitVehicleType.isRequired,
  route: simpleRouteType.isRequired,
  vehicleCenteringActive: PropTypes.bool,
  centerVehicleOnMap: PropTypes.func,
};

// vehicleCenteringActive + centerVehicleOnMap come from the redux hook
// useVehicleCentering = defaults for Storybook / jest
VehicleDetailHeader.defaultProps = {
  vehicleCenteringActive: true,
  centerVehicleOnMap: () => {},
};

export default VehicleDetailHeader;
